import React from 'react'
import SearchField from 'components/ui/SearchField'
import { useDispatch, useSelector } from 'react-redux'
import { updateSelectedFilters } from 'store/actions/filters'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { t } from 'ttag'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'

const FreeTextSearchContainer = styled.div`
  position: relative;
  padding-bottom: 16px;
`
const SearchIcon = styled.i`
  font-size: 25px;
  color: #9faee5;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 9px;
`

function FreeTextSearch({ type, values, isSummary, applySearch }) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const searchString = filters.selectedFilters[currentSearchable][type][values[0]]

  function handleSearchChange(event) {
    const string = event.target.value
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue: string
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSummary() {
    if (searchString !== '' && typeof searchString !== 'undefined') {
      return (
        <SelectedFilterContainer className="selected-filters">
          <SelectedFilter>
            <FilterText>
              <span>{searchString}</span>
            </FilterText>
          </SelectedFilter>
        </SelectedFilterContainer>
      )
    }
    return null
  }

  function handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      applySearch()
    }
  }

  return (
    <>
      {isSummary ? (
        renderSummary()
      ) : (
        <FreeTextSearchContainer>
          <SearchField
            placeholder={t`Search from document names`}
            aria-label={t`Search`}
            onChange={e => handleSearchChange(e)}
            value={searchString}
            onKeyDown={handleOnKeyDown}
            hideIcon
          />
          <SearchIcon onClick={() => applySearch()} className="far fa-search" />
        </FreeTextSearchContainer>
      )}
    </>
  )
}

FreeTextSearch.propTypes = {
  type: PropTypes.string,
  values: PropTypes.array,
  isSummary: PropTypes.bool,
  applySearch: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

export default FreeTextSearch
